/**
 * Created by Jerker Nord on 2019-09-02.
 */
import {
    IStillImageBackgroundConfig,
    StillImageBackground
} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BonusBunniesGameConfig} from "../BonusBunniesGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";

export class BonusBunniesBackground extends StillImageBackground {

    public static bonusBunniesBackground:BonusBunniesBackground;

    constructor(config:IStillImageBackgroundConfig) {
        super(config);
        BonusBunniesBackground.bonusBunniesBackground = this;
    }

    protected initAnimations():void {
        super.initAnimations();
    }
}